import { Moon, Sun } from "lucide-react";
import { useTheme } from "@/hooks/useTheme";

interface ThemeToggleProps {
  className?: string;
}

/**
 * Bouton de bascule Dark / Light.
 * - Persiste le choix dans localStorage
 * - Applique la classe sur <html> (.light / .dark)
 */
export const ThemeToggle = ({ className = "" }: ThemeToggleProps) => {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === "dark";

  return (
    <button
      type="button"
      onClick={toggleTheme}
      aria-label={isDark ? "Activer le mode clair" : "Activer le mode sombre"}
      title={isDark ? "Mode clair" : "Mode sombre"}
      className={`press-scale relative inline-flex size-9 items-center justify-center rounded-full border border-border bg-background/60 text-foreground/80 backdrop-blur transition-colors duration-300 hover:border-primary/40 hover:text-foreground ${className}`}
    >
      <Sun
        className={`absolute size-4 transition-all duration-300 ${
          isDark ? "scale-0 -rotate-90 opacity-0" : "scale-100 rotate-0 opacity-100"
        }`}
      />
      <Moon
        className={`absolute size-4 transition-all duration-300 ${
          isDark ? "scale-100 rotate-0 opacity-100" : "scale-0 rotate-90 opacity-0"
        }`}
      />
    </button>
  );
};
